module.exports = __webpack_public_path__ + "img/00503660_mieng_dan_lanh_chong_say_tau_xe_mdt_hop_10_mieng_4825_6422_large_05323428c1.2eddc856.webp";